import { createSlice, current } from "@reduxjs/toolkit";
import { reset } from "../actions";

const initialState = {
  page: 0,
  data: {
    orderNumber: "",
    orderAmount: 0,
    orderForm: 20,
    orderStatus: 1,
    sampleAmount: 0,
    dropBoxId: null,
    dropBoxDate: "",
    sampleData: [],
  },
  billingInformation: {
    firstName: "",
    lastName: "",
    company: "",
    phone: "",
    email: "",
    shippingOption: "Dropbox",
    dropboxLocation: "",
    dropoffDate: "",
    billingMethod: "",
    purchasingAgentName: "",
    purchasingAgentEmail: "",
    poNumber: "",
    grantNumber:"",
    grantPi: "",
    grantNote: "",
    ccNumber: "",
    ccMonth: "",
    ccYear: "",
    cvv: "",
	ccZip: "",
    cardType: "",
    ccName: "",
    acgtCard: "",
  },
};

const genomicFormSlice = createSlice({
  name: "genomicorderform",
  initialState,
  reducers: {
    //action creators
    initializeGenomicSampleData(state, action) {
      for (let i = 0; i < action.payload; i++) {
        const newData = {
          id: i + 1,
          templateName: "",
          ampliconAmount: 0,
          ampliconData: [],
          consensus: "",
          purification: "",
        };
        state.data.sampleData.push(newData);
      }
      return;
    },
    clearGenomicSelect(state, action) {
      const { index, property } = action.payload;
      // console.log(index, property);
      
      state.data.sampleData[index] = {
        ...state.data.sampleData[index],
        [property]: "", // Set the specified property to an empty string for the specific row
      };

      return;
    },
    clearGenomicSelectAmplicon(state, action) {
      const { index, subIndex, property } = action.payload;
      // console.log(index, subIndex, property);

      state.data.sampleData[index] = {
        ...state.data.sampleData[index],
        ampliconData: state.data.sampleData[index].ampliconData.map((item, i) =>
          i === subIndex
            ? { ...item, [property]: '' }  
            : item                         
        )
      };
      
      return;
    },
    genomicPrevStep: (state, action) => {
      state.page = state.page - 1;
    },
    genomicNextStep: (state, action) => {
      state.page = state.page + 1;
    },
    genomicSetStep: (state, action) => {
      state.page = action.payload;
    },
    resetGenomicPage: (state, action) => {
      state.page = action.payload;
    },
    resetGenomicState(state, action) {
      Object.assign(state, initialState);
      return;
    },
    resetGenomicSampleData(state, action) {
      state.data.sampleData = action.payload;
      return;
    },
    resetGenomicAmpliconData(state, action) {
      const { reset, index } = action.payload;
      state.data.sampleData[index].ampliconData = reset;
      return;
    },
    setGenomicSampleAmount(state, action) {
      state.data.sampleAmount = parseInt(action.payload);
      return;
    },
    addGenomicSample(state, action) {
      const newRow = action.payload;
      // Add the new row to the end of sampleData
      state.data.sampleData.push(newRow);

      // Reset the indices in the updated sampleData
      state.data.sampleData = state.data.sampleData.map((item, index) => ({
        ...item,
        id: index + 1,
      }));
      state.data.sampleAmount = parseInt(state.data.sampleAmount + 1);
      return;
    },

    deleteGenomicSample(state, action) {
      const { index } = action.payload;
      const updatedSampleData = state.data.sampleData.filter(
        (item, i) => i !== index
      );

      // Reset the indices in the updated SampleData
      const resetIndexedSampleData = updatedSampleData.map((item, i) => ({
        ...item,
        id: i + 1,
      }));

      // Update the SampleData state
      state.data.sampleData = resetIndexedSampleData;
      state.data.sampleAmount = parseInt(state.data.sampleAmount - 1);
      return;
    },
    setGenomicTemplateName(state, action) {
      const { value, index } = action.payload;
      const updatedData = [...state.data.sampleData];

      updatedData[index].templateName = value;

      // Assuming your state has a property named "sampleData"
      state.data.sampleData = updatedData;
    },
    setGenomicAmpliconAmount(state, action) {
      const { value, index } = action.payload;
      const updatedData = [...state.data.sampleData];

      updatedData[index].ampliconAmount = value;

      // Assuming your state has a property named "sampleData"
      state.data.sampleData = updatedData;
    },
    setGenomicGelPurification(state, action) {
      const { value, index } = action.payload;
      const updatedData = [...state.data.sampleData];

      updatedData[index].purification = value;

      // Assuming your state has a property named "sampleData"
      state.data.sampleData = updatedData;
    },
    setGenomicConsensus(state, action) {
      const { value, index } = action.payload;
      const updatedData = [...state.data.sampleData];

      updatedData[index].consensus = value;

      // Assuming your state has a property named "sampleData"
      state.data.sampleData = updatedData;
    },
    initializeGenomicAmplicon(state, action) {
      const { count, index } = action.payload;

      for (let i = 0; i < count; i++) {
        const newData = {
          id: i + 1,
          gene: "",
          location: "",
          targetLength: "",
          primerDesign: "",
          forwardPrimerName: "",
          forwardPrimerSequence: "",
          reversePrimerName: "",
          reversePrimerSequence: "",
          comments: "",
        };
        state.data.sampleData[index].ampliconData.push(newData);
      }
      return;
    },
    addGenomicAmplicon(state, action) {
      const { index } = action.payload;
      const newRow = {
        gene: "",
        location: "",
        targetLength: "",
        primerDesign: "",
        consensus: "",
        forwardPrimerName: "",
        forwardPrimerSequence: "",
        reversePrimerName: "",
        reversePrimerSequence: "",
        comments: "",
      };

      // console.log(newRow, index);

      state.data.sampleData[index-1].ampliconData.push(newRow);

      // // Reset the indices in the updated sampleData
      state.data.sampleData[index-1].ampliconData = state.data.sampleData[
        index - 1
      ].ampliconData.map((item, index) => ({
        ...item,
        id: index + 1,
      }));

      // console.log('haha',state.data.sampleAmount);
      if(state.data.sampleData[index-1].ampliconAmount){
        state.data.sampleData[index-1].ampliconAmount = parseInt(state.data.sampleData[index-1].ampliconAmount)+1
      }
      else{
        state.data.sampleData[index-1].ampliconAmount = 1
      }

      return;
    },
    editGenomicAmplicon(state, action) {
      const { index, subIndex, value, input } = action.payload;
      const pattern = /^[a-zA-Z0-9-_]{0,20}$/;

      // Create a deep copy of the ampliconData array
      const updatedAmpliconData = state.data.sampleData[index].ampliconData.map(
        (obj, i) => {
          // If the current index is the one being edited, update its properties
          if (i === subIndex) {
            return {
              ...obj,
              [input]: value,
            };
          }
          // Otherwise, return the original object
          return obj;
        }
      );

      // Create a new copy of the sampleData array, updating the ampliconData for the specified sample index
      const updatedSampleData = state.data.sampleData.map((sample, i) => {
        if (i === index) {
          return {
            ...sample,
            ampliconData: updatedAmpliconData,
          };
        }
        return sample;
      });

      // Update the state with the modified sampleData
      state.data.sampleData = updatedSampleData;
    },
    deleteGenomicAmplicon(state, action) {
      const { index, subIndex } = action.payload;
      const updatedSampleData = state.data.sampleData[
        index
      ].ampliconData.filter((item, i) => i !== subIndex);

      // Reset the indices in the updated SampleData
      const resetIndexedSampleData = updatedSampleData.map((item, i) => ({
        ...item,
        id: i + 1,
      }));

      // Update the SampleData state
      state.data.sampleData[index].ampliconData = resetIndexedSampleData;
      state.data.sampleData[index].ampliconAmount = parseInt(
        state.data.sampleData[index].ampliconAmount - 1
      );
      return;
    },
    setGenomicDropboxLocation(state, action) {
      state.billingInformation.dropboxLocation = action.payload.label;
      return;
    },
    setGenomicDropboxId(state, action) {
      state.data.dropBoxId = action.payload;
      return;
    },
    setGenomicDropoffDate(state, action) {
      state.billingInformation.dropoffDate = action.payload;
      state.data.dropBoxDate = action.payload;
      // Test the regular expression with a date
      // if (dateRegex.test(result)) {
      // }
    },
    setGenomicFirstName(state, action) {
      state.billingInformation.firstName = action.payload;
      return;
    },
    setGenomicLastName(state, action) {
      state.billingInformation.lastName = action.payload;
      return;
    },
    setGenomicCompany(state, action) {
      state.billingInformation.company = action.payload;
    },
    setGenomicPhone(state, action) {
      const phoneRegex = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
      const result = action.payload;

      // Test the regular expression with a date
      // if (phoneRegex.test(result)) {
      //   state.billingInformation.phone = result;
      // }
      state.billingInformation.phone = result;
    },
    setGenomicEmail(state, action) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      state.billingInformation.email = action.payload;
    },
    setGenomicShippingOption(state, action) {
      state.billingInformation.shippingOption = action.payload;
      return;
    },
    setGenomicAcgtCard(state, action) {
      state.billingInformation.acgtCard = action.payload;
      return;
    },
    setGenomicCCNumber(state, action) {
      state.billingInformation.ccNumber = action.payload;
      return;
    },
    setGenomicCCMonth(state, action) {
      state.billingInformation.ccMonth = action.payload;
      return;
    },
    setGenomicCCYear(state, action) {
      state.billingInformation.ccYear = action.payload;
      return;
    },
    setGenomicCVV(state, action) {
      state.billingInformation.cvv = action.payload;
      return;
    },
	setGenomicCCZip(state, action) {
      state.billingInformation.ccZip = action.payload;
      return;
    },
    setGenomicCCName(state, action) {
      state.billingInformation.ccName = action.payload;
      return;
    },
    setGenomicCardType(state, action) {
      state.billingInformation.cardType = action.payload;
      return;
    },
    setGenomicBillingMethod(state, action) {
      state.billingInformation.billingMethod = action.payload;
      return;
    },
    setGenomicPurchasingAgentName(state, action) {
      state.billingInformation.purchasingAgentName = action.payload;
      return;
    },
    setGenomicPurchasingAgentEmail(state, action) {
      state.billingInformation.purchasingAgentEmail = action.payload;
      return;
    },
    setGenomicPoNumber(state, action) {
      state.billingInformation.poNumber = action.payload;
      return;
    },
    setGenomicOrderNumber(state, action) {
      state.data.orderNumber = action.payload;
      return;
    },
    setGenomicOrderAmount(state, action) {
      state.data.orderAmount = action.payload;
      return;
    },
    setGenomicGrantNumber(state, action) {
      state.billingInformation.grantNumber = action.payload;
      return;
    },
    setGenomicGrantPI(state, action) {
      state.billingInformation.grantPi = action.payload;
      return;
    },
    setGenomicGrantNote(state, action) {
      state.billingInformation.grantNote = action.payload;
      return;
    },
  },
  extraReducers(builder) {
    builder.addCase(reset, (state, action) => {
      return {};
    });
  },
});

export const {
  initializeGenomicSampleData,
  genomicPrevStep,
  clearGenomicSelect,
  clearGenomicSelectAmplicon,
  genomicNextStep,
  genomicSetStep,
  resetGenomicPage,
  resetGenomicState,
  resetGenomicSampleData,
  resetGenomicAmpliconData,
  setGenomicSampleAmount,
  addGenomicSample,
  deleteGenomicSample,
  setGenomicTemplateName,
  setGenomicAmpliconAmount,
  setGenomicGelPurification,
  setGenomicConsensus,
  initializeGenomicAmplicon,
  addGenomicAmplicon,
  editGenomicAmplicon,
  deleteGenomicAmplicon,
  setGenomicDropoffDate,
  setGenomicDropboxLocation,
  setGenomicDropboxId,
  setGenomicFirstName,
  setGenomicLastName,
  setGenomicCompany,
  setGenomicPhone,
  setGenomicEmail,
  setGenomicShippingOption,
  setGenomicAcgtCard,
  setGenomicCCNumber,
  setGenomicCCMonth,
  setGenomicCCYear,
  setGenomicCVV,
  setGenomicCCZip,
  setGenomicCCName,
  setGenomicCardType,
  setGenomicPurchasingAgentName,
  setGenomicPurchasingAgentEmail,
  setGenomicPoNumber,
  setGenomicOrderNumber,
  setGenomicOrderAmount,
  setGenomicGrantNumber,
  setGenomicGrantPI,
  setGenomicGrantNote,
  setGenomicBillingMethod,
} = genomicFormSlice.actions;

export const genomicFormReducer = genomicFormSlice.reducer;
